import { ProviderStatisticsMap } from '@models/Statistics';
import { TitleType, TitleTypes } from '@models/Title';

export const ContentStatisticsPageTabs = ['channels', 'providers', 'sources'] as const;
export type ContentStatisticsPageTab = (typeof ContentStatisticsPageTabs)[number];
export const defaultContentStatisticsPageTab: ContentStatisticsPageTab = 'providers';

export const ContentStatisticsViewModes = ['chart', 'list'] as const;
export type ContentStatisticsViewMode = (typeof ContentStatisticsViewModes)[number];

export type ViewTitleTypeMap = Record<TitleType, boolean>;

export type ContentStatisticsViewProps = {
  stats?: ProviderStatisticsMap;
};

export const TitleTypesWithTotal = [...TitleTypes, 'total'] as const;
export type TitleTypeOrTotal = (typeof TitleTypesWithTotal)[number];
